import useStyles from "./styles"
import { ThumbnailsApi, ThumbnailsFiles, ThumbnailStepper } from "../Thumbnail"
import VehicleNewsStepper from "../News/VehicleNewsStepper"
import DeviceNewsStepper from "../News/DeviceNewsStepper"
import theme from "../../theme"
import { tabletBreakpoint } from "../../lib/helper/viewportHelper"
import { useMediaQuery } from "@material-ui/core"
import React from "react"

const Home = () => {
    const classes = useStyles()
    const isSmall = useMediaQuery(theme.breakpoints.down(tabletBreakpoint))

    return (
        <main className={classes.content}>
            <ThumbnailStepper
                id="thumbnail-stepper"
                thumbnailsUrl="Home/Slide.json"
                srcWidth="1500"
                className={classes.thumbnailStepper}
            />

            <ThumbnailsApi
                id="thumbnails-bignews"
                length={6}
                thumbnailSizes={[{ srcWidth: isSmall ? "670" : "440" }]}
            />

            <DeviceNewsStepper />
            <VehicleNewsStepper />

            <ThumbnailsFiles
                id="thumbnails-1-2-3"
                length={6}
                thumbnailsUrl="Home/1-2-3.json"
                thumbnailSizes={[
                    { percent: "100%", srcWidth: "1500" },
                    { percent: isSmall ? null : "48%", srcWidth: "670" }, { percent: isSmall ? null : "48%", srcWidth: "670" },
                    { srcWidth: isSmall ? "670" : "460" }, { srcWidth: isSmall ? "670" : "460" }, { srcWidth: isSmall ? "670" : "460" }
                ]}
            />
            <ThumbnailsFiles
                id="thumbnails-1-1-1-1-1-1"
                length={6}
                thumbnailsUrl="Home/1-1-1-1-1-1.json"
                thumbnailSizes={[{ percent: "100%", srcWidth: "1500" }]}
            />
        </main>
    )
}

export default Home
